<template>
    <div class="">
        <h5 class="info-head">联系人信息<span v-if="!basicIsShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span>&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" @click="showLinkShow" style="text-decoration: underline;color: blue;">查看联系人说明</a>
            <el-button v-if="basicIsShow" icon="el-icon-plus" @click="add">新增</el-button></h5>
        <table border strip class="info-table">
        <tr>
            <th>序号</th>
            <th><b>*</b>姓名</th>
            <th><b>*</b>身份证</th>
            <th><b>*</b>类型</th>
            <th>职务</th>
            <th><b>*</b>手机</th>
            <th>办公电话</th>
            <th><b>*</b>邮箱</th>
            <th>备注</th>
            <th>状态</th>
            <th>附件</th>
            <th>操作</th>
        </tr>
        <tr v-for="c, i in linkpersons">
            <td>{{i+1}}</td>
            <td>{{c.fpersonname}}</td>
            <td>{{c.idCard}}</td>
            <td>{{contactTypes[c.personType]}}</td>
            <td>{{c.fposition}}</td>
            <td>{{c.fphone}}</td>
            <td>{{c.fworkphone}}</td>
            <td>{{c.femail}}</td>
            <td>{{c.remark}}</td>
            <td>
                {{c.approveStatus=='0'?"待审批":""}}
                {{c.approveStatus=='1'?"审批中":""}}
                {{c.approveStatus=='2'?"已认证":""}}
                {{c.approveStatus=='3'?"已认证":""}}
            </td>
            <td>
                <div v-for="(file,i) in c.baseFiles" :key="i">
                    <a v-if="file.id" :href="downloadApi +'?name='+ file.fileOldName +'&path='+ file.filePath" target="_blank">{{ file.fileOldName }}</a>
                    <span v-else>{{file.fileOldName}}</span>
                </div>
            </td>
            <td>
                <a v-if="basicIsShow && (c.id==null || (c.personType!='4' || c.approveStatus=='0'))" @click.prevent="edit(i)" class="edit-btn">编辑</a>
                <a @click.prevent="remove(i)" class="delete-btn"  v-if="i>1 && basicIsShow && (c.id==null || (c.personType!='4' || c.approveStatus=='0'))">删除</a>
            </td>
        </tr>
        <tr v-if="!linkpersons.length"><td colspan=9>暂无数据</td></tr>
        </table>
        <div class="splitter"></div>
        <div class="text-center">
            <el-button v-if="basicIsShow" :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
        <el-dialog :title="isNaN(editIndex)?'新增联系人':'编辑联系人'" :visible.sync="contactFormVisible">
            <el-form :model="contact" label-width="100px" :rules="rules" ref="contactForm" class="supplier-form">
                <el-form-item label="姓名：" prop="fpersonname">
                    <el-input type="text" v-model.trim="contact.fpersonname" auto-complete="off" :disabled="(editIndex<1 || (!isNaN(editIndex)))&&hasYRZ"></el-input>
                </el-form-item><!--:disabled="editIndex===0"-->
                <el-form-item label="身份证：" prop="idCard">
                    <el-input type="text"  v-model="contact.idCard" auto-complete="off" :disabled="(editIndex<1 || (!isNaN(editIndex)))&&hasYRZ"></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="personType">
                    <el-select v-if="editIndex===0" v-model="contact.personType" placeholder="请选择" style="float:left" ref="personType" :disabled="true">
                        <el-option
                            v-for="type in contactTypes.slice(0,1)"
                            :key="'0'"
                            :label="type"
                            :value="'0'">
                        </el-option>
                    </el-select>
                    <el-select v-if="!isNaN(editIndex) && editIndex!=0 && contact.personType!='4'" v-model="contact.personType" placeholder="请选择" style="float:left" ref="personType" :disabled="editIndex==1">
                        <el-option
                            v-for="type,i in contactTypes.slice(1,4)"
                            :key="i+1+''"
                            :label="type"
                            :value="i+1+''">
                        </el-option>
                    </el-select>
                    <el-select v-if="isNaN(editIndex)" v-model="contact.personType" placeholder="请选择" style="float:left" ref="personType" :disabled="editIndex==1">
                        <el-option
                            v-for="type,i in contactTypes.slice(1)"
                            :key="i+1+''"
                            :label="type"
                            :value="i+1+''">
                        </el-option>
                    </el-select>
                    <el-select v-if="!isNaN(editIndex) && contact.personType=='4'" v-model="contact.personType" placeholder="请选择" style="float:left" ref="personType" :disabled="true">
                        <el-option
                            v-for="type,i in contactTypes.slice(4)"
                            :key="4"
                            :label="type"
                            :value="4+''">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职务：" prop="fposition"><el-input type="text" v-model="contact.fposition" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="手机：" prop="fphone"><el-input type="text" v-model="contact.fphone" auto-complete="off" :maxlength="11" :disabled="(editIndex<1 || (!isNaN(editIndex)))&&hasYRZ"></el-input></el-form-item>
                <el-form-item label="办公电话：" prop="fworkphone"><el-input type="text" v-model="contact.fworkphone" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="备注：" prop="remark"><el-input type="text" v-model="contact.remark" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="邮箱：" prop="femail"><el-input type="text" v-model="contact.femail" auto-complete="off" :disabled="(editIndex<1 || (!isNaN(editIndex)))&&hasYRZ"></el-input></el-form-item>
                <el-form-item v-if="contact.personType=='4'" label="上传附件：" prop="baseFiles">
                    <el-upload class="upload"
                               :action="uploadApi"
                               :on-success="handleChange"
                               :on-error="uploadError"
                               :on-remove="handleRemove"
                               :before-remove="beforeRemove"
                               :before-upload="beforeUpload"
                               multiple
                               :limit="5"
                               :on-exceed="handleExceed"
                               :file-list="contact.baseFiles">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="contactFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitContact">确 定</el-button>
        </div>
        </el-dialog>
        <el-dialog title="联系人说明" :visible.sync="showDialogShow" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>

            <div>
                <p>① 业务对接人：指公司日常业务的对接人，该人员需要与公司内部相关业务部门做好衔接沟通，做好内部信息互通；该人员必须为公司缴纳社保的员工，手机号必须是本人实名制。该人员在一个公司只能是唯一且不可修正，如需修改，需提交申请；</p>
                <p>② 上级负责人：指公司负责人或业务分管负责人，可统筹协调公司内部资源对项目提供支持；必须为该公司缴纳社保的员工，手机号必须是本人实名制。该人员将在业务履约过程参与会议、约谈，并能进行一定的决策。</p>
                <p>③ 技术负责人：指公司的总工，即技术负责人、技术专家，熟悉该产品及服务类别的规范、施工要求，具备较强的识图能力，对于针对大华业务投标，施工等技术问题，有统筹判断能力，并能输出相关工程施工实施方案；</p>
                <p>④ 工程负责人：指公司针对大华项目的实际决策人，即老板、出资人，对项目履约承担最终责任，负责签确所有经济性文件。一个公司只能锁定一个工程负责人。</p>
                <p>⑤ 项目经理：指已中标项目的实际现场管理负责人，必须具备相关经验，并经相关认证，黑名单人员将禁入大华业务合作，不得参与后续任何企业的项目投标；该人员必须为公司缴纳社保的员工，手机号必须是本人实名制。</p>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeLinkShwo">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { contactRules  } from '@/util/rules'
    import apis from '@/store/apis'
    import util from '@/util'

    export default {
        name: 'supplier-contact',
        data () {
            return {
                uploadApi: `${util.baseUrl}rest/file/upload?type=2`,
                downloadApi: `${util.baseUrl}rest/api/sftp/download`,
                rules: contactRules,
                contact:{
                    fpersonname:'',
                    idCard: '',
                    personType:'',
                    fposition:'',
                    fphone:'',
                    fworkphone:'',
                    fpersonfax:'',
                    remark:'',
                    femail:'',
                    approveStatus:'',
                    baseFiles: []
                },
                contactFormVisible:false,
                editIndex:void(0),//用于编辑、标记新增
                isSubmit:false,
                basicIsShow: false,  // 判断信息是否修改
                hasYRZ:true,//是否含有已认证的专业类别
                showDialogShow:false
            }
        },
        computed: mapGetters(['linkpersons','contactTypes']),
        methods: {
            ...mapActions(['getLinkPersons','addOrEditContact','removeContact','submitContacts']),
            add(){
                this.editIndex = void(0)
                this.contact = {
                    fpersonname:'',
                    idCard: '',
                    personType:'',
                    fposition:'',
                    fphone:'',
                    fworkphone:'',
                    fpersonfax:'',
                    remark:'',
                    femail:'',
                    baseFiles: []
                }
                this.contactFormVisible = true
                this.$nextTick(()=>{
                    this.$refs.contactForm.resetFields()
                    switch(this.linkpersons.length){
                        case 0: this.contact.personType = '0'; break;
                        case 1: this.contact.personType = '1'; break;
                        default: break
                    }
                })
            },
            edit(i){
                this.editIndex = i
                this.contactFormVisible = true
                this.$nextTick(()=>{
                    this.contact = Object.assign({}, this.linkpersons[i])
//                    this.$refs.contactForm.resetFields()
                    switch(i){
                        case 0: this.contact.personType = '0'; break;
                        case 1: this.contact.personType = '1'; break;
                        default: break
                    }
                })
            },
            remove(i){
                this.$confirm('此操作将删除该条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeContact(i).then(()=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            submitContact(){
                console.log(this.contact,'this.contact')
                this.$refs.contactForm.validate((valid) => {
                    if (valid) {
                        let payload = {contact:this.contact, editIndex:this.editIndex}
                        this.addOrEditContact(payload)
                        this.contactFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            submit(){
            	this.isSubmit=true;
                this.submitContacts().then((res) => {
                    if(res.data.result){
                        this.$confirm(res.data.message||'操作成功！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            showClose: false,
                            type: 'success',
                            center: true
                        }).then(() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        },() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        })
                        window.sessionStorage.setItem(this.$route.name,'saved')
                    }else{
                    	this.isSubmit=false;
                        this.$alert(res.data.message)
                    }
                }, err => {
                	this.isSubmit=false;
                    this.$alert(err)
                })
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
            },
            showLinkShow(){
                this.showDialogShow = true;
            },
            closeLinkShwo(){
                this.showDialogShow = false;
            },
            beforeUpload(file){
                if(!util.allowUpload(file.name)){
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                    return false
            }
                return true
            },
            handleChange(response, file, fileList){
                this.contact.baseFiles = this.__getBaseFiles__(file,fileList)
            },
            uploadError(){
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
            },
            handleRemove(file, fileList) {
                this.contact.baseFiles = this.contact.baseFiles.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            __getBaseFiles__(file,fileList){
                let fs = [];
                fileList.forEach((item) => {
                    if(item.response){
                        let f = item.response.basefiles[0];
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item);
                });
                return fs.filter(item => !!item.filePath)
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
        },
        created(){
            console.log(this.contactTypes.slice(4),'wudi');
            this.$root.loading = true
            Promise.all([this.getLinkPersons()]).then(r=>{
                this.$nextTick(function(){
                    this.$root.loading = false
                })
            }).catch(err=>this.$root.loading = false)
            this.$set(this.rules,'baseFiles',[
                {required: true, message: '请上传附件', trigger:'change'}
            ]);
        },
        mounted(){
            this.basicIsShow = window.sessionStorage.getItem('basicIsShow')=='true'?true:false
            this.hasYRZ = window.sessionStorage.getItem('hasYRZ')=='true'?true:false

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Contact.vue